import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Input } from '@/components/ui/input';

interface BlogSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const BlogSearch = ({ searchTerm, onSearchChange }: BlogSearchProps) => {
  return (
    <div className="mb-8">
      <div className="relative max-w-md">
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
        <Input
          placeholder="Search articles..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
};

export default BlogSearch;